module.exports = __webpack_public_path__ + "media/images/StarTribune-black-bc16349999660411307caaabc30201b5.png";